import { ArrowIcon, Box, Flex, Heading, Text } from '@modusign/design-system';

import Header from '@app/components/Header';
import HelpButton from '@app/components/HelpButton';
import ModusignIcon from '@app/components/Icons/ModusignIcon';

interface ExcelUploadPageHeaderProps {
  onExit: () => void;
}

export default function ExcelUploadPageHeader({ onExit }: ExcelUploadPageHeaderProps) {
  return (
    <Flex sx={{ zIndex: 500 }}>
      <Header>
        <Flex flex="1" justifyContent="flex-start">
          <Flex
            alignItems="center"
            as="button"
            sx={{ cursor: 'pointer' }}
            type="button"
            onClick={onExit}
          >
            <Box width="30px">
              <ArrowIcon direction="left" height="21px" width="14px" />
            </Box>
            <ModusignIcon />
            <Text fontSize="medium" ml={2}>
              주소록
            </Text>
          </Flex>
        </Flex>
        <Flex alignItems="center" flex="1" justifyContent="center" sx={{ userSelect: 'none' }}>
          <Heading color="textNeutralLightest" fontSize="sm" fontWeight="medium">
            연락처 추가
          </Heading>
        </Flex>
        <Flex alignItems="center" flex="1" justifyContent="flex-end" pr={6}>
          <HelpButton variant="darkIcon" />
        </Flex>
      </Header>
    </Flex>
  );
}
